<template>
    <div class="user-detail-body">
        <div class="user-inp">
            <div>
                <label>Email</label>           
                <vue-select v-if="props.onlyLocalUsers" label="email" :options="userStore.getAll" :clearable="false" :reduce="(item) => item.id"
                    v-model="state.selected" @option:selected="(a: any) => selectedUser(a)" 
                    :disabled="false" :appendToBody="true"/>
                <vue-select v-else label="mail" :options="azureStore.getGroupMembers" :clearable="false"
                    v-model="props.user.email" @option:selected="(a: any) => selectedUser(a)" @search="handleSearch"
                    :disabled="false"/>
            </div>
            <div>
                <div>
                    <label>Given name</label>
                    <div class="row">
                        <input type="string" v-model="props.user.firstName" :disabled="!state.canEditName" />
                        <dx-button hint="Enable/Disable editing user name" icon="edit" @click="() => state.canEditName = !state.canEditName"/>
                    </div>
                </div>
                <div>
                    <label>Surname</label>
                    <input type="string" v-model="props.user.lastName" :disabled="!state.canEditName" />
                </div>
            </div>
        </div>        
    </div>
</template>

<script lang="ts" setup>

import { onMounted, reactive, ref } from 'vue';
import VueSelect from 'vue-select';
import { UserItem } from '@/services/entities/UserItem';
import { useUserStore } from '@/stores/user';
import { useAzureStore } from '@/stores/azure';
import { debounce } from '@/common/util';
import { Authorization } from '@/services/authenticate';
import { DxButton } from 'devextreme-vue';

const userStore = useUserStore();
const azureStore = useAzureStore();

const props = defineProps({
    user: {Type: {} as UserItem, default: {} as UserItem},
    onlyLocalUsers: {Type: {} as boolean, default: false},
});

const state = reactive({
    canEditName: false,
    selected: ""
});

onMounted(async () => {
    await userStore.loadAll();
    await azureStore.loadGroupMembers();
});


const handleSearch = debounce(async (query: string) => {
    if (query != "")
        await azureStore.searchUser(query);
}, 500);

function selectedUser(option: any) {    
    if (!option) return;

    props.user.id = option.id;
    if (props.onlyLocalUsers) {
        props.user.email = option.email;
        props.user.firstName = option.firstName;
        props.user.lastName = option.lastName;
        props.user.fullName = option.fullName;
    }
    else {
        props.user.email = option.mail;
        props.user.firstName = option.givenName;
        props.user.lastName = option.surname;
        if (props.user.lastName && props.user.firstName) {
            props.user.fullName = `${option.givenName} ${option.surname}`;
        } else {
            props.user.fullName = option.mail;
        }        
    }    
}

</script>

<style lang="scss" scoped>
.user-detail-body {
    height: calc(200px);
    overflow: auto;
}

.user-inp {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    &>div {
        min-width: 350px;
        padding-top: 5px;

        input {
            width: 288px;
            margin-left: 0;
        }

        .v-select {
            width: 300px;
        }
    }
}

.user-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    padding-top: 0.5rem;

    :first-child {
        margin-right: 1rem;
    }

    .user-column {
        margin-left: 35px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        &>div {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            align-content: center;
        }
    }

    .v-select {
        width: 300px;
    }

    input[type=radio] {
        width: 35px;
    }

    .user-actions {
        margin-left: 55px;
    }
}

.usr-selector {
    padding-top: 5px;
}

.row {
    display: flex;
    flex-direction: row;
}
</style>